// import ConverterPageBaseComponent from './converter/converter-page-base.component';
// import AVCutterComponent from './cutter/av-cutter.component';
// import FileDownloadComponent from './downloads/file-download.component';
// import FAQPageComponent from './faq/faq-pages.component';
// import FAQComponent from './faq/faq.component';
// import ImageCompressComponent from './image-editor/image-compress.component';
// import ImageResizeRootComponent from './image-editor/image-resize-root.component';
// import MemeGeneratorComponent from './meme/meme-generator.component';
// import AccountVerifyPageComponent from './portal/account/account-verify-page.component';
// import PasswordResetPageComponent from './portal/account/password-reset-page.component';
// import PortalComponent from './portal/portal.component';
// import SinglePageBaseComponent from './single-page-converters/single-page-base.component';
// import StaticPageComponent from './static-pages/static-page.component';
// import PricePageComponent from './ui/product/price-page.component';
// import ProductPageComponent from './ui/product/product-page.component';
import dynamic from 'next/dynamic';


const FileDownloadComponent = dynamic(() => import('./downloads/file-download.component'));
const FAQPageComponent = dynamic(() => import('./faq/faq-pages.component'));
const FAQComponent = dynamic(() => import('./faq/faq.component'));
const ImageCompressComponent = dynamic(() => import('./image-editor/image-compress.component'));
const ImageResizeRootComponent = dynamic(() => import('./image-editor/image-resize-root.component'));
const MemeGeneratorComponent = dynamic(() => import('./meme/meme-generator.component'));
const AccountVerifyPageComponent = dynamic(() => import('./portal/account/account-verify-page.component'));
const PasswordResetPageComponent = dynamic(() => import('./portal/account/password-reset-page.component'));
const PortalComponent = dynamic(() => import('./portal/portal.component'));
const SinglePageBaseComponent = dynamic(() => import('./single-page-converters/single-page-base.component'));
const StaticPageComponent = dynamic(() => import('./static-pages/static-page.component'));
const PricePageComponent = dynamic(() => import('./ui/product/price-page.component'));
const ProductPageComponent = dynamic(() => import('./ui/product/product-page.component'));
const ToolsComponent = dynamic(() => import('../pages/tools/[tools]'));
const ContactUsComponent = dynamic(() => import('./contact-us/contact-us.component'));
const ConverterPageBaseComponent = dynamic(() => import('./converter/converter-page-base.component'));
const AVCutterComponent = dynamic(() => import('./cutter/av-cutter.component'));

export const ROUTE_TO_COMPONENT_MAP: { [pathname: string]: any } = {
    'portal': PortalComponent,
    'product': ProductPageComponent,
    'product/backer_monthly': PricePageComponent,
    'product/patron_monthly': PricePageComponent,
    'product/backer_yearly': PricePageComponent,
    'product/patron_yearly': PricePageComponent,

    'tools': ToolsComponent,
    'tools/convert': ToolsComponent,
    'tools/compress': ToolsComponent,
    'tools/split': ToolsComponent,
    'tools/merge': ToolsComponent,
    'tools/resize': ToolsComponent,
    'tools/meme': ToolsComponent,
    'tools/count': ToolsComponent,
    'tools/encode': ToolsComponent,
    'tools/decode': ToolsComponent,
    'tools/crop': ToolsComponent,
    'tools/trim': ToolsComponent,
    'tools/cut': ToolsComponent,

    'contact-us': ContactUsComponent,

    'faq': FAQComponent,
    'faq/how-can-i-make-a-pdf-file': FAQPageComponent,
    'faq/how-do-i-make-a-postscript-compatible-file-without-a-postscript-compatible-printer': FAQPageComponent,
    'faq/how-long-are-files-stored-on-the-server': FAQPageComponent,
    'faq/who-has-access-to-the-converted-files': FAQPageComponent,
    'faq/where-are-the-converted-files-stored': FAQPageComponent,
    'faq/how-can-i-specify-the-paper-size': FAQPageComponent,
    'faq/i-hit-convert-and-nothing-happens': FAQPageComponent,
    'faq/is-there-a-size-limit-to-the-converted-files': FAQPageComponent,
    'faq/how-do-i-get-color-output': FAQPageComponent,
    'faq/i-get-error-number-sign-x-when-converting-the-document-and-the-resulting-pdf-file-didn-not-open': FAQPageComponent,
    'faq/when-i-view-the-pdf-file-it-doesn-not-look-like-my-original-document': FAQPageComponent,
    'faq/how-can-i-get-more-information-on-pdf-file-formats': FAQPageComponent,
    'faq/how-can-i-create-a-html-file-from-pdf-file': FAQPageComponent,
    'faq/how-can-i-purchase-the-xconvert.com-software': FAQPageComponent,
    'faq/how-can-i-convert-files-on-my-own-computer-without-uploading-them-to-your-site': FAQPageComponent,
    'faq/i-am-having-problems-installing-ghostscript': FAQPageComponent,

    'about-us': StaticPageComponent,
    'privacy-policy': StaticPageComponent,
    'how-to-help-xconvert-to-grow': StaticPageComponent,
    'terms-of-service': StaticPageComponent,
    'link-us': StaticPageComponent,

    'convert-video-to-mp3': ConverterPageBaseComponent,
    'audio-converter': ConverterPageBaseComponent,
    'convert-mp4-to-mp3': ConverterPageBaseComponent,
    'convert-ogg-to-mp3': ConverterPageBaseComponent,
    'convert-m4a-to-mp3': ConverterPageBaseComponent,
    'convert-m4a-to-wav': ConverterPageBaseComponent,
    'convert-wav-to-mp3': ConverterPageBaseComponent,
    'convert-mp3-to-wav': ConverterPageBaseComponent,
    'convert-flac-to-mp3': ConverterPageBaseComponent,
    'convert-wma-to-mp3': ConverterPageBaseComponent,
    'convert-aiff-to-mp3': ConverterPageBaseComponent,
    'convert-aac-to-mp3': ConverterPageBaseComponent,
    'convert-flac-to-wav': ConverterPageBaseComponent,
    'convert-mp3-to-m4a': ConverterPageBaseComponent,
    'convert-opus-to-mp3': ConverterPageBaseComponent,
    'convert-mp3-to-m4r': ConverterPageBaseComponent,
    'convert-mp4-to-wav': ConverterPageBaseComponent,
    'convert-webm-to-mp3': ConverterPageBaseComponent,
    'audio-trimmer': AVCutterComponent,
    'audio-cutter': AVCutterComponent,
    'mp3-trimmer': AVCutterComponent,
    'mp3-cutter': AVCutterComponent,
    'compress-mp3': ConverterPageBaseComponent,
    'compress-wav': ConverterPageBaseComponent,
    'compress-m4r': ConverterPageBaseComponent,
    'audio-compressor': ConverterPageBaseComponent,
    'convert-pdf-to-epub': ConverterPageBaseComponent,
    'convert-pdf-to-mobi': ConverterPageBaseComponent,
    'convert-mobi-to-epub': ConverterPageBaseComponent,
    'convert-epub-to-mobi': ConverterPageBaseComponent,
    'resize-jpg': ImageResizeRootComponent,
    'resize-png': ImageResizeRootComponent,
    'resize-image': ImageResizeRootComponent,
    'image-resizer': ImageResizeRootComponent,
    'edit-image': ImageResizeRootComponent,
    'resize-tiff': ImageResizeRootComponent,
    'resize-webp': ImageResizeRootComponent,
    'crop-jpg': ImageResizeRootComponent,
    'crop-png': ImageResizeRootComponent,
    'crop-image': ImageResizeRootComponent,
    'crop-tiff': ImageResizeRootComponent,
    'crop-webp': ImageResizeRootComponent,
    'convert-video-to-mp4': ConverterPageBaseComponent,
    'video-converter': ConverterPageBaseComponent,
    'mp4-converter': ConverterPageBaseComponent,
    'convert-video-to-webm': ConverterPageBaseComponent,
    'convert-mkv-to-mp4': ConverterPageBaseComponent,
    'convert-avi-to-mp4': ConverterPageBaseComponent,
    'convert-mov-to-mp4': ConverterPageBaseComponent,
    'convert-webm-to-mp4': ConverterPageBaseComponent,
    'convert-flv-to-mp4': ConverterPageBaseComponent,
    'convert-m4v-to-mp4': ConverterPageBaseComponent,
    'convert-wmv-to-mp4': ConverterPageBaseComponent,
    'convert-mts-to-mp4': ConverterPageBaseComponent,
    'convert-mpg-to-mp4': ConverterPageBaseComponent,
    'convert-mkv-to-webm': ConverterPageBaseComponent,
    'convert-avi-to-webm': ConverterPageBaseComponent,
    'convert-mov-to-webm': ConverterPageBaseComponent,
    'convert-webm-to-webm': ConverterPageBaseComponent,
    'convert-flv-to-webm': ConverterPageBaseComponent,
    'convert-m4v-to-webm': ConverterPageBaseComponent,
    'convert-wmv-to-webm': ConverterPageBaseComponent,
    'convert-mts-to-webm': ConverterPageBaseComponent,
    'convert-mpg-to-webm': ConverterPageBaseComponent,
    'convert-gif-to-video': ConverterPageBaseComponent,
    'convert-gif-to-mp4': ConverterPageBaseComponent,
    'convert-gif-to-webm': ConverterPageBaseComponent,
    'convert-video-to-gif': ConverterPageBaseComponent,
    'convert-mp4-to-gif': ConverterPageBaseComponent,
    'convert-webm-to-gif': ConverterPageBaseComponent,
    'convert-mov-to-gif': ConverterPageBaseComponent,
    'video-cutter': AVCutterComponent,
    'video-trimmer': AVCutterComponent,
    'meme-generator': MemeGeneratorComponent,
    'compress-jpg-image-online': ImageCompressComponent,
    'compress-jpg': ConverterPageBaseComponent,
    'compress-gif': ConverterPageBaseComponent,
    'compress-jpeg': ConverterPageBaseComponent,
    'compress-png': ConverterPageBaseComponent,
    'compress-image': ConverterPageBaseComponent,
    'image-compressor': ConverterPageBaseComponent,
    'compress-tiff': ConverterPageBaseComponent,
    'compress-webp': ConverterPageBaseComponent,
    'compress-heic': ConverterPageBaseComponent,

    'convert-jpg-to-png': ConverterPageBaseComponent,
    'convert-png-to-jpg': ConverterPageBaseComponent,
    'convert-jpg-to-webp': ConverterPageBaseComponent,
    'convert-webp-to-jpg': ConverterPageBaseComponent,
    'convert-jpg-to-tiff': ConverterPageBaseComponent,
    'convert-tiff-to-jpg': ConverterPageBaseComponent,
    'convert-png-to-webp': ConverterPageBaseComponent,
    'convert-webp-to-png': ConverterPageBaseComponent,
    'convert-png-to-tiff': ConverterPageBaseComponent,
    'convert-tiff-to-png': ConverterPageBaseComponent,
    'convert-jpg-to-heic': ConverterPageBaseComponent,
    'convert-heic-to-jpg': ConverterPageBaseComponent,
    'convert-webp-to-heic': ConverterPageBaseComponent,
    'convert-heic-to-webp': ConverterPageBaseComponent,
    'convert-png-to-heic': ConverterPageBaseComponent,
    'convert-heic-to-png': ConverterPageBaseComponent,
    'convert-tiff-to-heic': ConverterPageBaseComponent,
    'convert-heic-to-tiff': ConverterPageBaseComponent,
    'convert-cr2-to-jpg': ConverterPageBaseComponent,
    'convert-nef-to-jpg': ConverterPageBaseComponent,

    // TO DELETE: Duplicate page with proper canonical
    'jpg-to-png': ConverterPageBaseComponent,
    'png-to-jpg': ConverterPageBaseComponent,
    'jpg-to-webp': ConverterPageBaseComponent,
    'webp-to-jpg': ConverterPageBaseComponent,
    'jpg-to-tiff': ConverterPageBaseComponent,
    'tiff-to-jpg': ConverterPageBaseComponent,
    'png-to-webp': ConverterPageBaseComponent,
    'webp-to-png': ConverterPageBaseComponent,
    'png-to-tiff': ConverterPageBaseComponent,
    'tiff-to-png': ConverterPageBaseComponent,
    'jpg-to-heic': ConverterPageBaseComponent,
    'heic-to-jpg': ConverterPageBaseComponent,
    'webp-to-heic': ConverterPageBaseComponent,
    'heic-to-webp': ConverterPageBaseComponent,
    'png-to-heic': ConverterPageBaseComponent,
    'heic-to-png': ConverterPageBaseComponent,
    'tiff-to-heic': ConverterPageBaseComponent,
    'heic-to-tiff': ConverterPageBaseComponent,
    'cr2-to-jpg': ConverterPageBaseComponent,
    'nef-to-jpg': ConverterPageBaseComponent,

    'compress-pdf': ConverterPageBaseComponent,
    'compress-mp4': ConverterPageBaseComponent,
    'compress-webm': ConverterPageBaseComponent,
    'video-compressor': ConverterPageBaseComponent,
    'compress-mkv': ConverterPageBaseComponent,
    'compress-avi': ConverterPageBaseComponent,
    'compress-mov': ConverterPageBaseComponent,
    'compress-flv': ConverterPageBaseComponent,
    'compress-m4v': ConverterPageBaseComponent,
    'compress-wmv': ConverterPageBaseComponent,
    'compress-mts': ConverterPageBaseComponent,
    'compress-mpg': ConverterPageBaseComponent,
    'convert-pdf-to-word': ConverterPageBaseComponent,
    'convert-word-to-pdf': ConverterPageBaseComponent,
    'convert-excel-to-pdf': ConverterPageBaseComponent,
    'convert-powerpoint-to-pdf': ConverterPageBaseComponent,
    'convert-pdf-to-powerpoint': ConverterPageBaseComponent,
    'word-to-jpg': ConverterPageBaseComponent,
    'convert-pdf-to-image': ConverterPageBaseComponent,
    'convert-image-to-pdf': ConverterPageBaseComponent,
    'split-pdf': ConverterPageBaseComponent,
    'merge-pdf': ConverterPageBaseComponent,
    'combine-pdf': ConverterPageBaseComponent,
    'pdf-combiner': ConverterPageBaseComponent,
    'pdf-merger': ConverterPageBaseComponent,
    'merge-image-to-pdf': ConverterPageBaseComponent,
    'convert-pdf-to-jpg': ConverterPageBaseComponent,
    'convert-jpg-to-pdf': ConverterPageBaseComponent,
    'convert-tiff-to-pdf': ConverterPageBaseComponent,
    'convert-pdf-to-png': ConverterPageBaseComponent,
    'convert-png-to-pdf': ConverterPageBaseComponent,
    'convert-ps-to-pdf': ConverterPageBaseComponent,
    'convert-pdf-to-ps': ConverterPageBaseComponent,

    'url-encoder': SinglePageBaseComponent,
    'url-decoder': SinglePageBaseComponent,
    'word-count': SinglePageBaseComponent,
    'base64-encode': SinglePageBaseComponent,
    'base64-decode': SinglePageBaseComponent,

    'rar-to-zip': ConverterPageBaseComponent,
    'zip-to-rar': ConverterPageBaseComponent,
    'tar-to-zip': ConverterPageBaseComponent,
    'zip-to-tar': ConverterPageBaseComponent,
    '7z-to-zip': ConverterPageBaseComponent,
    'unzip-files': ConverterPageBaseComponent,
    'unzip-tar.gz': ConverterPageBaseComponent,
    'zip-extractor': ConverterPageBaseComponent,
    'rar-extractor': ConverterPageBaseComponent,
    'rar-files': ConverterPageBaseComponent,
    '7zip': ConverterPageBaseComponent,

    'password-reset': PasswordResetPageComponent,
    'verify': AccountVerifyPageComponent,

    'downloads': FileDownloadComponent,
}